import React from 'react';
import Select from 'react-select';
import SearchField from '../../components/SearchField';
import ModuleFilter from '../../components/ModuleFilter';

export const AreaControlFilter = (props) => {

    const handleQueryChange = (query) => {
        props.updateQuery(query);
    };

    const applyModuleFilter = (modulesSelected) => {

        const selectedModuleValues = modulesSelected.map(selectedModule => selectedModule.value);

        props.updateModuleFilter(selectedModuleValues);
    };

    const applyReplenishmentStatusFilter = (filterOption) => {
        props.updateReplenishmentStatusFilter(filterOption.value);
    };

    const applyStatusFilter = (filterOption) => {
        props.updateStockStatusFilter(filterOption.value);
    };

    const applyRefillStatusFilter = (filterOption) => {
        props.updateRefillStatusFilter(filterOption.value);
    };

    const moduleOptions = props.modules.map((module) => {
        return {
            value: module.name.toString(),
            label: module.name.toString()
        };
    });

    const stockStatusFilterOptions = [
        {value: 'ALL', label: 'Alle'},
        {value: 'UNSYNCHRONIZED', label: 'keine Synchronisation'},
        {value: 'IN_STOCK', label: 'mit Bestand'},
        {value: 'OUT_OF_STOCK', label: 'ohne Bestand'}
    ];

    const stockStatusFilterOption = stockStatusFilterOptions.find(option => option.value === props.filters.stockStatus);

    const replenishmentStatusFilterOptions = [
        {value: 'ALL', label: 'Alle'},
        {value: 'ACTIVE', label: 'aktiv'},
        {value: 'HALTED', label: 'angehalten'},
        {value: 'STOPPED', label: 'gestoppt'}
    ];

    const refillStatusFilterOptions = [
        {value: 'ALL', label: 'Alle'},
        {value: 'APPROVED', label: 'Ja'},
        {value: 'DISAPPROVED', label: 'Nein'}
    ];

    const refillStatusFilterOption = refillStatusFilterOptions.find(option => option.value === props.filters.refillStatus);

    const replenishmentStatusFilterOption = replenishmentStatusFilterOptions.find(option => option.value === props.filters.replenishmentStatus);

    return (
        <div className="row">
            <div className="col-2">
                <label>Flächenbestand</label>
                <Select
                    name="status"
                    value={stockStatusFilterOption}
                    onChange={applyStatusFilter}
                    options={stockStatusFilterOptions}
                />
            </div>
            <div className="col-2">
                <label>Flächensteuerung</label>
                <Select
                    name="active"
                    value={replenishmentStatusFilterOption}
                    onChange={applyReplenishmentStatusFilter}
                    options={replenishmentStatusFilterOptions}
                />
            </div>
            <div className="col-2">
                <label>Freigabe für Nachversorgung</label>
                <Select
                        name="approvedForRefill"
                        value={refillStatusFilterOption}
                        onChange={applyRefillStatusFilter}
                        options={refillStatusFilterOptions}
                />
            </div>
            <div className="col-3">
                <label>Modulauswahl</label>
                <ModuleFilter
                        moduleOptions={moduleOptions}
                        onChange={applyModuleFilter}
                />
            </div>
            <div className="col-3">
                <label>&nbsp;</label>
                <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={props.query} onCommit={handleQueryChange}/>
            </div>
        </div>
    )
};

export default AreaControlFilter;



// WEBPACK FOOTER //
// ./src/admin/areacontrol/overview/AreaControlFilter.js